// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__1ojKO","col":"styles_col__VLw4r"};